import React from 'react';
import ReactDOM from 'react-dom/client';
import './semantic-layer.css';
import './tailwind-output.css';
import './index.css';
import App from '../src/Components/App/App';
import reportWebVitals from './reportWebVitals';
import { MsalProvider } from '@azure/msal-react';

import { PublicClientApplication } from '@azure/msal-browser';
import { ThemeProvider } from './contexts/ThemeContext';

const msalConfig = {
    auth: {
      clientId: process.env.REACT_APP_MSAL_CLIENT_ID,
      authority: process.env.REACT_APP_MSAL_AUTHORITY || "https://login.microsoftonline.com/common",
      redirectUri: `${window.location.origin}/auth-end`,
    },
    cache: {
      cacheLocation: "localStorage",
      storeAuthStateInCookie: true, 
    },
  };
const msalInstance = new PublicClientApplication(msalConfig);
(async () => {
  await msalInstance.initialize();

  const root = ReactDOM.createRoot(document.getElementById("root"));
  root?.render(
    <React.StrictMode>
      <ThemeProvider>
        <MsalProvider instance={msalInstance}>
          <App />
        </MsalProvider>
      </ThemeProvider>
    </React.StrictMode>
  );
})();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
